exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Viewer-local__pageModal--2MucE {\n  padding: 2rem 3rem; }\n  .Viewer-local__pageModal--2MucE iframe {\n    border: none;\n    width: 100%;\n    height: 85vh; }\n", ""]);

// exports
exports.locals = {
	"pageModal": "Viewer-local__pageModal--2MucE"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/runner/work/portal/portal/src","node_modules/foundation-sites/scss","node_modules/motion-ui/src","node_modules/slick-carousel/slick"]}!./src/components/Reveal/PageViewer/Viewer.local.scss
// module id = 845
// module chunks = 0